/**
 * @file objectFitImages.js
 */

import objectFitImages from 'object-fit-images'; // https://www.npmjs.com/package/object-fit-images

const someImages = document.querySelectorAll('img.js-object-fit-images');
objectFitImages(someImages);
